module.exports = __webpack_public_path__ + "img/5.04c513fd.jpg";